import { z } from "zod";

//QualidadeItemProcessosRiscosSchema

const optionalNumber =z.number().int().nullable().optional();
const optionalString = z.string().trim().nullable().optional().transform(e => e === '' ? null : e);
export const QualidadeItemProcessosRiscosSchema = z.object({
    IdItemProcesso: optionalNumber, 
    IdProcesso: optionalNumber, 
    IdFuncionarioResponsavel: optionalNumber, 
    IdFuncionarioCoresp: optionalNumber, 
    Descricao: z.string().nonempty("A descrição do item/risco não pode ser vazia."), 
    DataAtualizacao: z.coerce.date().nullable().optional(),
    Observacao: optionalString,
});

// QualidadeItemProcessosRiscosForm

export type QualidadeItemProcessosRiscosForm = z.infer<typeof QualidadeItemProcessosRiscosSchema>;